import { Outlet } from "react-router-dom";
import Header from "./NurtureProspects/Header";
import { SkeletonTheme } from "react-loading-skeleton";
import { NurtureProvider } from "../Context/NurtureContext";
import { Stack } from "@mui/material";
import { SideBarContainer } from "./NurtureProspects/Sidebar/SidebarContainer";
import { DesktopSideBar } from "./NurtureProspects/Sidebar/SidebarContainer/Desktop";

function AppLayout() {
  return (
    <SkeletonTheme baseColor="#E8EBF1" highlightColor="#edeff4">
      <NurtureProvider>
        <Stack direction="row" height="100vh" width={"100%"}>
          <SideBarContainer>
            {({ isMobile, sideBarContent }) => {
              if (isMobile) return;
              return <DesktopSideBar content={sideBarContent} />;
            }}
          </SideBarContainer>
          <Stack width="100%" direction="column">
            <Header />
            <Outlet />
          </Stack>
        </Stack>
      </NurtureProvider>
    </SkeletonTheme>
  );
}

export default AppLayout;
